import React from 'react';
import SideActionBoard from '../../../components/SideActionBoard';
import SystemBannerForm from './SystemBannerForm';

const SystemBannerSidebar = ({
  openSideActionBoard,
  setOpenSideActionBoard,
  onSuccess,
}) => {
  const { type, id } = openSideActionBoard;

  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <SystemBannerForm
        id={id}
        type={type}
        setOpenSideActionBoard={setOpenSideActionBoard}
        onSuccess={onSuccess}
      />
    </SideActionBoard>
  );
};

export default SystemBannerSidebar;

